"use client";

import { ChevronDownIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

import { cn } from "@/lib/utils";

import { DP_PARTNERSHIPS_EMAIL } from "./dp-data";
import { dpFaqs } from "./dp-faq-data";

export function DpFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-[860px] px-6 py-16 md:py-20">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <h2 className="text-marketing-text dark:text-marketing-cream text-heading-24! sm:text-heading-32! text-balance">
            FAQ
          </h2>
          <p className="text-marketing-text-muted text-copy-16 font-normal">
            Question not answered? Email us at{" "}
            <Link
              href={`mailto:${DP_PARTNERSHIPS_EMAIL}`}
              className="underline"
            >
              {DP_PARTNERSHIPS_EMAIL}
            </Link>
          </p>
        </div>

        <div className="flex flex-col">
          {dpFaqs.map((faq, index) => (
            <div key={faq.question} className="flex flex-col">
              <button
                onClick={() => {
                  setOpenIndex(openIndex === index ? null : index);
                }}
                className="flex w-full items-center justify-between gap-6 py-5 text-left"
              >
                <span className="text-marketing-text dark:text-marketing-cream text-copy-16 font-medium md:text-base">
                  {faq.question}
                </span>
                <div
                  className={cn(
                    "flex h-[18px] w-[18px] shrink-0 items-center justify-center transition-transform",
                    openIndex === index && "rotate-180",
                  )}
                >
                  <ChevronDownIcon className="text-marketing-text dark:text-marketing-cream h-[18px] w-[18px]" />
                </div>
              </button>

              <div
                className={cn(
                  "grid transition-[grid-template-rows,padding-bottom] duration-200 ease-in-out",
                  openIndex === index
                    ? "grid-rows-[1fr] pb-6"
                    : "grid-rows-[0fr]",
                )}
              >
                <div className="overflow-hidden">
                  <div className="text-marketing-text-muted dark:text-marketing-cream max-w-[680px] text-[14px] font-normal">
                    {faq.answer}
                  </div>
                </div>
              </div>

              {index < dpFaqs.length - 1 && (
                <div className="bg-marketing-border h-px w-full dark:bg-white/20" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
